import React from 'react';
import PropTypes from 'prop-types';
import { get, orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import IterationNavigation from '../../components/IterationNavigation';
import { sortOptions } from '../Homes';

const styles = css`
  margin-bottom:100px;
`;

function HomeDetailFooter({ home, homes }) {
  const filteredHomes = homes.filter(h => !h.is_project);

  return (
    <div className={styles}>
      <IterationNavigation
        homes={orderBy(filteredHomes, sortOptions[0].field, get(sortOptions[0], 'dir', 'asc'))}
        currentHome={home}
        routeName="home-detail"
        label="Home"
      />
    </div>
  );
}

HomeDetailFooter.propTypes = {
  home: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    homes: true,
    home: true,
  },
)(HomeDetailFooter);



// WEBPACK FOOTER //
// ./src/pages/PlanDetail/PlanDetailFooter.js